var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShowers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 320,
    height: 320,
    viewBox: "30 30 260 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "showers_svg__c",
    points: "-17 337.051 238.956 337.051 238.956 .923 -17 .923"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "showers_svg__a",
    cx: 117.269,
    cy: 116.859,
    r: 116.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(43 43)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 116.5,
    cy: 116.5,
    r: 116.5,
    fill: "currentColor",
    transform: "translate(.77 .359)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "showers_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#showers_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#showers_svg__a"
  }), /*#__PURE__*/React.createElement("polyline", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 14.769,
    points: "111.214 119.826 165.801 119.826 165.801 249.667",
    mask: "url(#showers_svg__b)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.483,
    x2: 130.24,
    y1: 113.72,
    y2: 136.736,
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 14.769,
    mask: "url(#showers_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M104.265 148.999a5.958 5.958 0 01-8.251 1.679 5.953 5.953 0 01-1.68-8.251 5.948 5.948 0 018.252-1.68 5.953 5.953 0 011.679 8.252M121.642 160.506a5.958 5.958 0 01-8.25 1.679c-2.743-1.817-3.496-5.514-1.68-8.251a5.948 5.948 0 018.251-1.679 5.953 5.953 0 011.68 8.251M86.885 137.492a5.957 5.957 0 01-8.25 1.678 5.958 5.958 0 01-1.68-8.256 5.951 5.951 0 018.252-1.673 5.952 5.952 0 011.678 8.25M92.587 155.85a5.963 5.963 0 011.679 8.256c-1.817 2.737-5.514 3.49-8.251 1.674a5.948 5.948 0 01-1.679-8.251 5.952 5.952 0 018.251-1.68M116.171 171.468a5.957 5.957 0 011.679 8.25c-1.817 2.743-5.514 3.496-8.251 1.68a5.95 5.95 0 01-1.679-8.251 5.952 5.952 0 018.251-1.68M69 140.232a5.958 5.958 0 011.679 8.251 5.953 5.953 0 01-8.251 1.679 5.948 5.948 0 01-1.679-8.251A5.952 5.952 0 0169 140.23M81.902 171.987a5.955 5.955 0 11-6.578 9.93 5.955 5.955 0 016.578-9.93M111.693 191.715a5.951 5.951 0 011.674 8.252 5.952 5.952 0 01-8.252 1.678 5.963 5.963 0 01-1.678-8.256 5.962 5.962 0 018.256-1.674M52.109 152.26a5.957 5.957 0 011.678 8.252 5.958 5.958 0 01-8.256 1.679 5.955 5.955 0 016.577-9.93",
    mask: "url(#showers_svg__b)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "showers_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#showers_svg__c"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "149.262 94.437 238.956 94.437 238.956 24.465 149.262 24.465",
    mask: "url(#showers_svg__d)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "89.201 94.437 142.414 94.437 142.414 7.289 89.201 7.289",
    mask: "url(#showers_svg__d)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "-17 94.437 82.22 94.437 82.22 42.065 -17 42.065",
    mask: "url(#showers_svg__d)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "94.02 26.878 137.594 26.878 137.594 15.776 94.02 15.776",
    mask: "url(#showers_svg__d)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "94.02 46.57 137.594 46.57 137.594 35.468 94.02 35.468",
    mask: "url(#showers_svg__d)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "94.02 66.262 137.594 66.262 137.594 55.161 94.02 55.161",
    mask: "url(#showers_svg__d)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "98.84 96.111 131.613 96.111 131.613 71.185 98.84 71.185",
    mask: "url(#showers_svg__d)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "44.046 64.372 76.563 64.372 76.563 53.27 44.046 53.27",
    mask: "url(#showers_svg__d)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "44.046 84.064 76.563 84.064 76.563 72.962 44.046 72.962",
    mask: "url(#showers_svg__d)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "4.662 64.372 37.178 64.372 37.178 53.27 4.662 53.27",
    mask: "url(#showers_svg__d)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "4.662 84.064 37.178 84.064 37.178 72.962 4.662 72.962",
    mask: "url(#showers_svg__d)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "155.628 41.647 188.15 41.647 188.15 30.545 155.628 30.545",
    mask: "url(#showers_svg__d)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "155.628 71.185 188.15 71.185 188.15 60.084 155.628 60.084",
    mask: "url(#showers_svg__d)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "195.012 41.647 227.534 41.647 227.534 30.545 195.012 30.545",
    mask: "url(#showers_svg__d)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "195.012 71.185 227.534 71.185 227.534 60.084 195.012 60.084",
    mask: "url(#showers_svg__d)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowers);
export default __webpack_public_path__ + "static/media/showers.b4b14913.svg";
export { ForwardRef as ReactComponent };